import { render, staticRenderFns } from "./resolved-order.vue?vue&type=template&id=14d8f50a&"
import script from "./resolved-order.vue?vue&type=script&lang=js&"
export * from "./resolved-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports